exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-home-js": () => import("./../../../src/pages/home.js" /* webpackChunkName: "component---src-pages-home-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-laser-treatments-js": () => import("./../../../src/pages/laser-treatments.js" /* webpackChunkName: "component---src-pages-laser-treatments-js" */),
  "component---src-pages-sugaring-js": () => import("./../../../src/pages/sugaring.js" /* webpackChunkName: "component---src-pages-sugaring-js" */)
}

